import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';

class NavbarGeneralVehicles extends Component {
  render() {
    const { history, closeDrawer } = this.props;
    const { pathname } = history.location;

    return (
      <ul className="head nav navbar-nav">
        <li>
          <Link
            className="navbar--regular-weight navbar--tight-margin"
            // onClick={closeDrawer}
            to={
              pathname.includes('tor')
                ? '/tor/ev'
                : pathname.includes('sf')
                ? '/sf/ev'
                : pathname.includes('la')
                ? '/la/ev'
                : pathname.includes('nyc')
                ? '/nyc/ev'
                : null
            }>
            EV
          </Link>
        </li>
      </ul>
    );
  }
}

export default withRouter(NavbarGeneralVehicles);



// WEBPACK FOOTER //
// ./src/components/Layout/NavbarGeneralVehicles.js